import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../../../../util/styles/index.js';
import { pageCountLocation } from '../../../../../Carousel/helpers/pageCountLocation.js';
import { useCarouselV3Context } from '../../../hooks/useCarouselV3Context.js';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["pageCountPosition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var usePageCount = function usePageCount(props) {
  var _useCarouselV3Context = useCarouselV3Context(),
    carouselApi = _useCarouselV3Context.carouselApi,
    pageControl = _useCarouselV3Context.pageControl;
  var pageCountPosition = props.pageCountPosition,
    rest = _objectWithoutProperties(props, _excluded);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _React$useState = React.useState(1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentPage = _React$useState2[0],
    setCurrentPage = _React$useState2[1];
  var _React$useState3 = React.useState(1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    totalPages = _React$useState4[0],
    setTotalPages = _React$useState4[1];
  React.useEffect(function () {
    if (!carouselApi) {
      return undefined;
    }
    var updatePageInfo = function updatePageInfo() {
      var snapList = carouselApi.scrollSnapList();
      var selectedIndex = carouselApi.selectedScrollSnap();
      setCurrentPage(selectedIndex + 1); // Convert 0-based to 1-based
      setTotalPages(snapList.length);
    };

    // Update immediately
    updatePageInfo();

    // Listen for changes
    carouselApi.on('select', updatePageInfo);
    carouselApi.on('reInit', updatePageInfo);
    return function () {
      carouselApi.off('select', updatePageInfo);
      carouselApi.off('reInit', updatePageInfo);
    };
  }, [carouselApi]);

  // Conditional logic based on pageControl - similar to Carousel.tsx
  var shouldRender = totalPages > 1 && !!pageCountPosition;
  var isBelow = pageControl === 'below';
  var itemCount = "".concat(currentPage, "/").concat(totalPages);
  var justifyContent = pageCountPosition ? pageCountLocation(pageCountPosition) : 'center';

  // Positioning styles based on original Carousel pageCountElement logic
  var containerStyles = mapAdsStyles(_objectSpread({
    pointerEvents: 'none',
    display: 'flex',
    position: 'absolute',
    bottom: '0',
    start: '0',
    end: '0',
    mx: '16',
    justifyContent: justifyContent,
    zIndex: 1
  }, isBelow ? {
    mb: '24',
    pb: '16'
  } : {
    mb: '16',
    pb: '8'
  }));
  var pageCountProps = _objectSpread({
    theme: 'on-light',
    itemCount: itemCount
  }, rest);
  return {
    shouldRender: shouldRender,
    containerStyles: containerStyles,
    pageCountProps: pageCountProps
  };
};

export { usePageCount };
//# sourceMappingURL=usePageCount.js.map
